// src/layout/Topbar.jsx
// 画面上部のヘッダー。ページタイトル / ロールバッジ / ユーザーメニュー / ログアウト / 通知ベル。

import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ROLE_LABEL, ROLE_COLOR } from '../config/roles';
import { getPageLabel } from '../config/menu';
import Icon from '../components/Icon';

export default function Topbar({ user, onLogout, onMenuClick = () => {} }) {
  const location = useLocation();
  const title    = getPageLabel(location.pathname, user);
  const initial  = (user.name || user.student_id || '?').charAt(0).toUpperCase();

  return (
    <header className="topbar">
      {/* スマホ用メニューボタン（デスクトップではCSSで非表示）【2026-07-21】 */}
      <button className="mobile-menu-btn" aria-label="メニューを開く" onClick={onMenuClick}><Icon name="menu" size={22} /></button>
      <h1 className="topbar-title">{title}</h1>
      <div className="topbar-right">
        <span
          className="topbar-role"
          style={{ background: ROLE_COLOR[user.role] + '22', color: ROLE_COLOR[user.role] }}
        >
          {ROLE_LABEL[user.role]}
        </span>
        <Link to="/profile" className="topbar-user" title="アカウント設定を開く">
          <div className="topbar-avatar">{initial}</div>
          <div className="topbar-userinfo">
            <div className="topbar-username">{user.name || user.student_id}</div>
            <div className="topbar-userid">{user.student_id}</div>
          </div>
        </Link>
        <button className="topbar-logout" onClick={onLogout}>ログアウト</button>
        <NavLink
          to="/notifications"
          className={({ isActive }) => 'topbar-icon-btn' + (isActive ? ' active' : '')}
          title="通知を開く"
        >
          <Icon name="bell" size={19} />
        </NavLink>
      </div>
    </header>
  );
}
